import type { Contract } from "../types/contract";

export function normalizeStatus(value: string | null | undefined): Contract["status"] {
  const normalized = (value ?? "").trim().toLowerCase().split(" ").join("_");
  if (normalized === "approved") return "Approved";
  if (normalized === "pending_review") return "Pending Review";
  return "Draft";
}

export function statusQueryValue(status: Contract["status"] | "all"): string | undefined {
  if (status === "all") return undefined;
  return status.toLowerCase().split(" ").join("_");
}

/** List/badge label: `in_review` → "IN REVIEW"; existing spaced labels are uppercased. */
export function formatContractStatusForDisplay(status: string | null | undefined): string {
  return (status ?? "").trim().replace(/_/g, " ").toUpperCase();
}
